import React, {useRef, useState} from "react";
import link from "../../image/link/link.png"
import {Tooltip} from "antd";
import ZkModal from "../../../common/modal/zkModal";
import ZkFormItem from "../../../common/form/zkFormItem";
import Input from "antd/es/input";
import {DefaultUploadFile} from "../../../cmpts/uploadfile";
import Util from "../../../public/utils";
import {ZKY_URL_DISTRI_GOODS_UPLOAD} from "../../../public/variables";

const ImLink = (props) => {

    //三个input
    const [address, setAddress] = useState('')
    const [title, setTitle] = useState('')
    const [content, setContent] = useState('')

    //图片上传
    const [imgUrl, setImgUrl] = useState('')

    const modalRef = useRef(null)

    function openModal() {
        modalRef.current.show()
    }

    function onChange(e, type) {
        let value = e.target.value
        if (type == 'address') {
            setAddress(value)
        } else if (type == 'title') {
            setTitle(value)
        } else if (type == 'content') {
            setContent(value)
        }
    }

    function uploadCodeImg(files) {
        Util.uploadImage(files, ZKY_URL_DISTRI_GOODS_UPLOAD, (msg) => {
            $('.upload-img-4').css('height', 'auto');
            // let codeImg = this.state.codeImg;
            let url = msg.respMsg.url;
            setImgUrl(url)
        })
    }

    function sendLink() {
        let obj = {
            title: title,
            address: address,
            content: content,
            url: imgUrl,
        }
        props.getLink(obj)
        modalRef.current.hide()
    }

    return (
        <>
            <Tooltip placement="top" title={'链接'}>
                <img src={link} className={'im-link'} onClick={openModal}/>
            </Tooltip>

            <ZkModal title={'发送链接'} ref={modalRef} width={520} onOk={sendLink}
                     okButtonProps={{disabled: address == '' || title == ''}}
                     className={'modal-right-btn'}>
                <ZkFormItem title={'链接'} colon={true} required>
                    <Input className={'im-set-link'} placeholder={'链接地址请以，http://或https'}
                           onChange={e => onChange(e, 'address')}
                           value={address}
                    />
                </ZkFormItem>
                <ZkFormItem title={'标题'} colon={true} required>
                    <Input className={'im-set-link'} placeholder={'请输入标题'}
                           onChange={e => onChange(e, 'title')}
                           value={title}
                    />
                </ZkFormItem>
                <ZkFormItem title={' 摘要'} colon={true} titleWidth={48}>
                    <Input className={'im-set-link'} placeholder={'请输入摘要'}
                           onChange={e => onChange(e, 'content')}
                           value={content}
                    />
                </ZkFormItem>
                <ZkFormItem title={'封面'} colon={true} titleWidth={48}>
                    <div
                        className={`goods-upload-img upload-img-4 ${imgUrl ? 'imgHeight' : ''}`}>
                        <div className={'add_img'}>
                            <div className='con'>
                                    <span
                                        className={imgUrl ? 'imgReloadIcon' : 'imgIcon'}></span>
                                <p className={imgUrl ? 'whiteTip' : ''}>{
                                    imgUrl ? '替换图片' : '上传图片'
                                }</p>
                            </div>
                        </div>
                        <img className={'goodImg'}
                             src={imgUrl}/>
                        <DefaultUploadFile btnText="上传图片"
                                           selectFile={uploadCodeImg}
                                           accept="image/jpeg, image/png, image/jpg"
                                           className={'uploadCustomer'}/>
                    </div>
                </ZkFormItem>
            </ZkModal>
        </>
    )
}

export default ImLink